import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { envs } from '../../redux/api/windowServerData'
import { MuiBox } from 'components/storybook'
import Footer from 'components/Footer'
import Header from './Header'
import Loader from 'components/Loader/Loader.jsx'
import { GetThemeFromAPILogin } from '../../redux/api/themeColor'

export function PolyCyPage() {
	const [policyData, setPolicyData] = useState(null)
	const [themeStorage, setThemeStorage] = useState(null)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const fetchData = async () => {
			const BASE_URL = envs.REACT_APP_GERMINI_API_URL

			try {
				const [policyResponse, themeResponse] = await Promise.all([
					axios.get(`${BASE_URL}/ProgramRules/PrivacyPolicies`),
					GetThemeFromAPILogin()
				])

				setPolicyData(policyResponse?.data || {})
				setThemeStorage(themeResponse || {})
			} catch (error) {
				console.error('Erro ao carregar dados da página de política:', error)
			} finally {
				setLoading(false)
			}
		}

		fetchData()
	}, [])

	return (
		<MuiBox
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				alignItems: 'center',
				gap: '40px',
				minHeight: '100vh',
			}}
		>
			{loading && <Loader />}
			<Header themeStorage={themeStorage} />
			<MuiBox
				sx={{
					flex: 1,
					maxWidth: '1138px',
					width: '100%',
				}}
			>
				<span
					dangerouslySetInnerHTML={{
						__html: policyData?.privacyPolicies || '',
					}}
				/>
			</MuiBox>
			<Footer themeStorage={themeStorage} />
		</MuiBox>
	)
}
